import { useEffect, useState } from "react";
import { useSelector } from "react-redux";


const NonMarginSubContent = ({ cashBalanceDetails, marginParticularsList, particularsMessage2, particularsMessage1, fromDate }) => {
    const [showDiv, setShowDiv] = useState(false);
    const dashboardDetails = useSelector((state) => state.Dashboard);

    const headerStyle = {
        backgroundColor: '#004080',
        color: '#fff',
        fontSize: '13px',
        fontFamily: 'Roboto Regular',
        fontWeight: "normal",
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        verticalAlign: 'middle',
        textAlign: "center",
        padding: "4px 5px"
    };

    const tdStyle = {
        background: '#e0e0e0',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: "4px 5px",
        color: "#000",
        fontSize: '13px',

    }
    const totalTd = {
        fontFamily: "Roboto Black",
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        // padding:"1px",
        fontSize: "13px"
    }
    const total = {
        fontFamily: "Roboto Black",
        fontSize: "13px"
    }
    const avoidPageBreak = {
        pageBreakInside: "avoid",
        breakInside: "avoid-column" // For browsers that support the modern "break-*"
    };

    useEffect(() => {
        if (dashboardDetails.reportClickDateDashhboard) {
            console.log("🚀 ~ useEffect ~ fromDate:", dashboardDetails.reportClickDateDashhboard)

            const fromMonth = new Date(dashboardDetails.reportClickDateDashhboard).getMonth();
            console.log("🚀 ~ useEffect ~ fromMonth:", fromMonth)

            const currentMonth = new Date().getMonth();
            console.log("🚀 ~ useEffect ~ currentMonth:", currentMonth, fromMonth === currentMonth);

            setShowDiv(fromMonth === currentMonth);
        }
        else {
            setShowDiv(false);
        }
    }, [dashboardDetails.reportClickDateDashhboard]);
    return (
        <div className="row m-0 py-3">
            <div className="col-6">
                <div className=" ">
                    <table className="table">
                        <thead >
                            <tr style={headerStyle}>
                                <th style={{ ...headerStyle, width: '50%' }}>Margin Details</th>
                                <th style={{ ...headerStyle, width: '50%' }}>Amount (AED)</th>
                            </tr>

                        </thead>
                        <tbody>
                            {marginParticularsList?.map((margin, index) =>
                                Object.entries(margin).map(([key, value], idx) => (
                                    <tr key={index + '-' + idx}>
                                        <td>{key}</td>
                                        <td className="text-end" style={{ color: Number(value) < 0 ? '#E43740' : 'black' }}>
                                            {Number(value) < 0
                                                ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(value)) || 0)})`
                                                : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value) || 0)}
                                        </td>
                                        {/* <td className="text-end">{parseFloat(value).toLocaleString()}</td> */}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="col-6" style={{ marginTop: 'auto' }}>
                {/* <div >
                    <span style={{
                        fontSize: '11px',
                        fontFamily: 'Roboto Medium',
                        display: 'block',
                        color: '#071A26',
                        marginBottom: '10px',
                        lineHeight: 1.3
                    }}>{particularsMessage1}</span>
                    <span style={{
                        fontSize: '11px',
                        fontFamily: 'Roboto Medium',
                        display: 'block',
                        color: '#071A26',
                        marginBottom: '15px',
                        lineHeight: 1.3
                    }}>{particularsMessage2}</span>
                </div> */}
                {console.log("showDivshowDivshowDiv", showDiv)}
                {showDiv ? (
                    <div>
                        <span style={{
                            fontSize: '11px',
                            fontFamily: 'Roboto Medium',
                            display: 'block',
                            color: '#071A26',
                            marginBottom: '10px',
                            lineHeight: 1.3
                        }}>{particularsMessage1}</span>
                        <span style={{
                            fontSize: '11px',
                            fontFamily: 'Roboto Medium',
                            display: 'block',
                            color: '#071A26',
                            marginBottom: '15px',
                            lineHeight: 1.3
                        }}>{particularsMessage2}</span>
                    </div>
                ) : (
                    <div></div> // Show empty div
                )}
                {cashBalanceDetails?.length > 0 &&
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr style={headerStyle}>
                                    <th style={{ ...headerStyle, width: '50%' }}>Cash Balance</th>
                                    <th style={{ ...headerStyle, width: '50%' }}></th>
                                </tr>
                            </thead>
                            {cashBalanceDetails?.length > 0 ?
                                <tbody>
                                    {cashBalanceDetails?.map((margin, index) => {
                                        const isLastMargin = index === cashBalanceDetails.length - 1;
                                        return Object.entries(margin).map(([key, value], idx, arr) => {
                                            const isLastRow = isLastMargin && idx === arr.length - 1;
                                            return (
                                                <tr
                                                    key={`${index}-${idx}`}
                                                    style={isLastRow ? { backgroundColor: '#A09171' } : {}}
                                                >
                                                    <td style={isLastRow ? { backgroundColor: '#A09171' } : {}}>{key}</td>
                                                    <td className="text-end" style={
                                                        isLastRow
                                                            ? {
                                                                backgroundColor: '#A09171',
                                                                borderBottomRightRadius: '10px',
                                                                color: parseFloat(value) < 0 ? '#E43740' : 'black',
                                                            }
                                                            : { color: parseFloat(value) < 0 ? '#E43740' : 'black' }
                                                    }>


                                                        {
                                                            parseFloat(value) < 0
                                                                ? `(${Math.abs(parseFloat(value)).toLocaleString()})`
                                                                : parseFloat(value).toLocaleString()
                                                        }

                                                    </td>

                                                </tr>
                                            );
                                        });
                                    })}
                                </tbody> :
                                <tbody>
                                    <tr style={{ textAlign: "center", padding: "30px 0" }}>
                                        <td colSpan="2" style={{ textAlign: "center", padding: "30px 0" }}>
                                            No Data
                                        </td>
                                    </tr>
                                </tbody>}
                        </table>
                    </div>}
            </div>
        </div>)
}
export default NonMarginSubContent